export enum ChannelTypes {
  association = 'association',
  district = 'district',
  team = 'team',
  club = 'club',
  league = 'league',
  event = 'event',
  unknown = 'unknown'
}
